function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();

      // Force-hide the poster and its play button via JS
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (poster) poster.style.display = 'none';

      this.setupPlayToggle(deferredElement);
    }
  }

  setupPlayToggle(mediaElement) {
    const posterButton = this.querySelector('.deferred-media__poster-button');
    if (!posterButton) return;

    const playToggle = posterButton.cloneNode(true);
    playToggle.classList.add('deferred-media__play-toggle');
    playToggle.style.display = 'none';
    this.appendChild(playToggle);
    // Hide the original poster button span in case it's still visible
    posterButton.style.display = 'none';

    if (mediaElement.tagName === 'VIDEO') {
      mediaElement.addEventListener('pause', () => {
        playToggle.style.display = '';
      });
      mediaElement.addEventListener('play', () => {
        playToggle.style.display = 'none';
      });
      mediaElement.addEventListener('ended', () => {
        playToggle.style.display = '';
      });

      playToggle.addEventListener('click', () => {
        if (mediaElement.muted) {
          mediaElement.currentTime = 0;
          mediaElement.muted = false;
        }
        mediaElement.play();
      });
    } else if (mediaElement.classList.contains('js-youtube')) {
      this.setupYouTube(mediaElement, playToggle);
    } else if (mediaElement.classList.contains('js-vimeo')) {
      this.setupVimeo(mediaElement, playToggle);
    }
  }

  setupYouTube(iframe, playToggle) {
    const showToggle = () => {
      playToggle.style.display = '';
    };
    const hideToggle = () => {
      playToggle.style.display = 'none';
    };

    window.addEventListener('message', (event) => {
      if (event.source !== iframe.contentWindow) return;
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        let state = null;
        if (data.event === 'onStateChange') state = data.info;
        if (data.event === 'infoDelivery' && data.info && typeof data.info.playerState !== 'undefined')
          state = data.info.playerState;
        if (state === null) return;
        if (state === 1 || state === 3) hideToggle();
        else if (state === 0 || state === 2) showToggle();
      } catch (e) {}
    });

    const startListening = () => {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
      } catch (e) {}
    };
    iframe.addEventListener('load', startListening);
    startListening();

    playToggle.addEventListener('click', () => {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'seekTo', args: [0, true] }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'unMute', args: '' }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: '' }), '*');
      } catch (e) {}
      hideToggle();
    });
  }

  setupVimeo(iframe, playToggle) {
    const showToggle = () => {
      playToggle.style.display = '';
    };
    const hideToggle = () => {
      playToggle.style.display = 'none';
    };

    window.addEventListener('message', (event) => {
      if (event.source !== iframe.contentWindow) return;
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (data.event === 'play') hideToggle();
        else if (data.event === 'pause' || data.event === 'ended') showToggle();
      } catch (e) {}
    });

    const subscribe = () => {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'play' }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'pause' }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'ended' }), '*');
      } catch (e) {}
    };
    iframe.addEventListener('load', subscribe);
    subscribe();

    playToggle.addEventListener('click', () => {
      try {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'setCurrentTime', value: 0 }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 1 }), '*');
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
      } catch (e) {}
      hideToggle();
    });
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.refreshOptionAvailability();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSubscriptionPicker();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery)
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
        false /* DAC don't scrollIntoView on variant change — caused the page to nudge down on each selection */,
      ); /* DAC add check before calling. Usage: Product Page Cross Sell */

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    /* DAC Preserve existing query params (e.g. split-test ?view=dac-julva-2) so
       switching variants doesn't drop the alternate template from the URL. */
    const params = new URLSearchParams(window.location.search);
    params.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', `${this.dataset.url}?${params.toString()}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    /* DAC Keep the split-test view param on the shareable URL as well. */
    const params = new URLSearchParams();
    params.set('variant', this.currentVariant.id);
    const view = new URLSearchParams(window.location.search).get('view');
    if (view) params.set('view', view);
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?${params.toString()}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  /**
   * DAC Add function to update subscription picker
   */
  updateSubscriptionPicker() {
    // Hide all boxes
    const a = document.querySelectorAll('.selling-plans');
    a.forEach((sellingPlans) => {
      sellingPlans.classList.add('hidden');
      sellingPlans.classList.remove('active');
    });
    // Unhide new variant's allocations
    if (this.currentVariant) {
      const id = this.currentVariant.id;
      const s = 'selling-plans_' + id + '_' + this.dataset.section;
      const b = document.getElementById(s);
      if (b) {
        b.classList.add('active');
        const c = document.querySelectorAll('#' + s + ' .selling-plan input');
        b.classList.remove('hidden');
        // Per-block override (layout 2) is on the fieldset; falls back to the theme setting
        const defaultOption = b.dataset.spDefault || subscriptionDefaultOption;
        if (defaultOption == 'subscription') {
          // Select first option for new variant
          c[0].checked = true;
        } else {
          // Select One-time
          c[c.length - 1].checked = true;
        }
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    /* DAC Allow for block level products */
    if (this.dataset.section.includes('-block')) {
      var fetchSection = this.dataset.section.split('-block')[0];
    } else {
      var fetchSection = this.dataset.section;
    }
    /* DAC END Mod */
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : fetchSection
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        /* DAC Inventory */
        const destinationInv = document.getElementById(`inventory-${this.dataset.section}`);
        const sourceInv = html.getElementById(
          `inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        /* DAC Variant Notes */
        const destinationNotes = document.getElementById(`variant-notes-${this.dataset.section}`);
        const sourceNotes = html.getElementById(
          `variant-notes-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        /* DAC Pre-order */
        const destinationPreorder = document.getElementById(`preorder-${this.dataset.section}`);
        const sourcePreorder = html.getElementById(
          `preorder-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceInv && destinationInv) destinationInv.innerHTML = sourceInv.innerHTML;
        if (sourceNotes && destinationNotes) destinationNotes.innerHTML = sourceNotes.innerHTML;
        if (sourcePreorder && destinationPreorder) {
          destinationPreorder.innerHTML = sourcePreorder.innerHTML;
          destinationPreorder.dataset.preorder = sourcePreorder.dataset.preorder;
        }

        /* Refresh option availability (e.g. disabled/unavailable combinations) to match the newly selected variant */
        const sourceOptions = html.querySelector(
          `${this.tagName.toLowerCase()}[data-section="${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }"]`,
        );
        if (sourceOptions) this.updateVariantOptions(sourceOptions);

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  updateVariantOptions(sourceOptions) {
    const isRadios = this.querySelector('fieldset') !== null;

    if (isRadios) {
      this.updateRadioOptions(sourceOptions);
    } else {
      this.updateSelectOptions(sourceOptions);
    }
  }

  updateRadioOptions(sourceOptions) {
    const oldFieldsets = Array.from(this.querySelectorAll('fieldset'));
    const newFieldsets = Array.from(sourceOptions.querySelectorAll('fieldset'));

    oldFieldsets.forEach((oldFieldset, index) => {
      const newFieldset = newFieldsets[index];
      if (!newFieldset) return;

      const oldInputs = Array.from(oldFieldset.querySelectorAll('input'));
      const newInputs = Array.from(newFieldset.querySelectorAll('input'));

      oldInputs.forEach((oldInput, inputIndex) => {
        const newInput = newInputs[inputIndex];
        if (!newInput) return;
        // const newLabel = newInput.getAttribute('aria-label');
        // if (oldInput.getAttribute('aria-label') !== newLabel) {
        //   if (newLabel === null) {
        //     oldInput.removeAttribute('aria-label');
        //   } else {
        //     oldInput.setAttribute('aria-label', newLabel);
        //   }
        // }

        const isUnavailable = newInput.classList.contains('disabled');
        if (isUnavailable !== oldInput.classList.contains('disabled')) {
          oldInput.classList.toggle('disabled', isUnavailable);
        }
        if (isUnavailable !== oldInput.hasAttribute('aria-disabled')) {
          if (isUnavailable) {
            oldInput.setAttribute('aria-disabled', 'true');
          } else {
            oldInput.removeAttribute('aria-disabled');
          }
        }

        const oldLabel = oldFieldset.querySelector(`label[for="${oldInput.id}"]`);
        const newLabel = newFieldset.querySelector(`label[for="${newInput.id}"]`);
        if (oldLabel && newLabel && oldLabel.innerHTML !== newLabel.innerHTML) {
          oldLabel.innerHTML = newLabel.innerHTML;
        }
      });
    });
  }

  updateSelectOptions(sourceOptions) {
    const oldSelects = Array.from(this.querySelectorAll('select'));
    const newSelects = Array.from(sourceOptions.querySelectorAll('select'));

    oldSelects.forEach((oldSelect, index) => {
      const newSelect = newSelects[index];
      if (!newSelect) return;

      const oldOptions = Array.from(oldSelect.options);
      const newOptions = Array.from(newSelect.options);

      oldOptions.forEach((oldOption, optionIndex) => {
        const newOption = newOptions[optionIndex];
        if (!newOption) return;

        oldOption.disabled = newOption.disabled;
        oldOption.textContent = newOption.textContent;
      });
    });
  }

  /* Refresh option availability when the selected combination has no matching variant
     (e.g. Capsules + 60 servings), using option value ids instead of a variant id */
  refreshOptionAvailability() {
    if (!this.optionValueIds || !this.optionValueIds.length) return;

    const isRadios = this.querySelector('fieldset') !== null;

    // Save current selections before updating DOM
    let currentSelections = [];
    if (isRadios) {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      currentSelections = fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    } else {
      const selects = Array.from(this.querySelectorAll('select'));
      currentSelections = selects.map((select) => select.value);
    }

    /* DAC Allow for block level products */
    if (this.dataset.section.includes('-block')) {
      var fetchSection = this.dataset.section.split('-block')[0];
    } else {
      var fetchSection = this.dataset.section;
    }
    /* DAC END Mod */
    fetch(
      `${this.dataset.url}?option_values=${this.optionValueIds.join(',')}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : fetchSection
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceOptions = html.querySelector(
          `${this.tagName.toLowerCase()}[data-section="${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }"]`,
        );
        if (sourceOptions) this.updateVariantOptions(sourceOptions);

        // After updating DOM, ensure selected options are still available
        const hasRadios = this.querySelector('fieldset') !== null;
        let selectionChanged = false;

        if (hasRadios) {
          const fieldsets = Array.from(this.querySelectorAll('fieldset'));
          fieldsets.forEach((fieldset, index) => {
            const currentSelection = currentSelections[index];

            // Check if currently selected option still exists and is available
            const currentInput = currentSelection
              ? Array.from(fieldset.querySelectorAll('input')).find(
                  (input) => input.value === currentSelection && !input.classList.contains('disabled'),
                )
              : null;

            // If current selection is not available, select the first available option
            if (!currentInput) {
              console.log('[DAC] Variant option radio unavailable. Finding new option.');

              const firstAvailable = fieldset.querySelector('input:not(.disabled)');
              if (firstAvailable) {
                console.log('[DAC] Found available variant option.');
                firstAvailable.checked = true;
                selectionChanged = true;
              }
            }
          });
        } else {
          const selects = Array.from(this.querySelectorAll('select'));
          selects.forEach((select, index) => {
            const currentSelection = currentSelections[index];

            // Check if currently selected option still exists and is available
            const currentOption = currentSelection
              ? Array.from(select.options).find(
                  (option) => option.value === currentSelection && !option.classList.contains('disabled'),
                )
              : null;

            // If current selection is not available, select the first available option
            if (!currentOption) {
              console.log('[DAC] Variant unavailable. Finding new option.');
              const firstAvailable = Array.from(select.options).find(
                (option) => !option.classList.contains('disabled'),
              );
              if (firstAvailable) {
                console.log('[DAC] Found available variant.');
                select.value = firstAvailable.value;
                selectionChanged = true;
              }
            }
          });
        }

        // Trigger change event if we made any changes
        if (selectionChanged) {
          this.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      /* DAC Pre-order: wrapper is re-rendered for the new variant in renderProductInfo */
      const preorderInfo = document.getElementById(`preorder-${this.dataset.section}`);
      addButtonText.textContent =
        preorderInfo && preorderInfo.dataset.preorder === 'true' && window.variantStrings.preorder
          ? window.variantStrings.preorder
          : window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.addEventListener('click', this.onRadioClick.bind(this));

    /* Capture phase, so the correction lands before the bubble-phase onVariantChange
       registered by VariantSelects reads the checked state. */
    this.addEventListener('change', this.correctUnavailableSelection.bind(this), true);
  }

  /* Arrow-key navigation checks a radio before any change handler runs. If the user
     lands on a sold-out option, move the selection to the first available one so the
     rest of the pipeline never sees an invalid combination. */
  correctUnavailableSelection(event) {
    const radio = event.target.closest('input[type="radio"]');
    if (!radio || !radio.checked || !radio.classList.contains('disabled')) return;

    const firstAvailable = radio.closest('fieldset')?.querySelector('input:not(.disabled)');
    if (firstAvailable && !firstAvailable.checked) firstAvailable.checked = true;
  }

  onRadioClick(event) {
    const radio = event.target.closest('input[type="radio"]');
    if (!radio || !radio.classList.contains('disabled')) return;

    event.preventDefault();

    /* Nothing to do when the fallback is already selected, and re-dispatching would
       trigger a needless fetch, history write and re-render. */
    const firstAvailable = radio.closest('fieldset')?.querySelector('input:not(.disabled)');
    if (!firstAvailable || firstAvailable.checked) return;

    firstAvailable.checked = true;
    firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const checkedRadios = fieldsets.map((fieldset) =>
      Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked),
    );
    this.options = checkedRadios.map((radio) => radio.value);
    this.optionValueIds = checkedRadios.map((radio) => radio.dataset.optionValueId);
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange, false);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantId();
    if (this.currentVariant) {
      this.updateAddButton();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateVariantId() {
    this.setAttribute('data-id', this.currentVariant.id);
    if (this.closest('.product-recommendation')) {
      this.closest('.product-recommendation')
        .querySelector('recommendations-add')
        .setAttribute('data-id', this.currentVariant.id);
    }
  }

  updateAddButton() {
    if (this.closest('.product-recommendation')) {
      this.buttonAdd = this.closest('.product-recommendation').querySelector('recommendations-add');
      if (this.currentVariant.available) {
        this.buttonAdd.classList.remove('disabled');
      } else {
        this.buttonAdd.classList.add('disabled');
      }
    }
  }
}

customElements.define('product-selects', ProductSelects);

/* DAC Custom */
/* DAC Open external links in a new tab */
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/* DAC Prevent single word last line (AKA Orphans or Widows) */
let dacSelectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote'];

let minWords = 4;
let maxLength = 13;

dacSelectors.forEach(function (selector) {
  let elements = document.querySelectorAll(selector);
  elements.forEach(function (element) {
    // Only operate on plain-text headings. If a heading wraps its content in a
    // link or any other element (e.g. product card titles), splitting innerHTML
    // on spaces catches the tag markup/attributes and injects a stray &nbsp;.
    if (element.children.length > 0) return;
    let words = element.innerHTML.trim().split(' ');
    let wordCount = words.length;
    let lineLength = (words[wordCount - 1] + words[wordCount - 2]).length;
    if (wordCount >= minWords && lineLength <= maxLength) {
      element.innerHTML = element.innerHTML.trim().replace(/ ([^ ]*)$/, '&nbsp;$1');
    }
  });
});

/* DAC Get Cookie */
function dacGetCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function dacShowDiscountPrice(prefixes) {
  let dsc = dacGetCookie('discount_code');
  prefixes.forEach((prefix) => {
    if (dsc.startsWith(prefix)) {
      let dac_cl_show = 'show-if-' + prefix;
      let dac_cl_hide = 'hide-if-' + prefix;
      let dac_show = document.getElementsByClassName(dac_cl_show);
      for (var i = 0; i < dac_show.length; i++) {
        dac_show[i].style.display = 'block';
      }
      let dac_hide = document.getElementsByClassName(dac_cl_hide);
      for (var i = 0; i < dac_hide.length; i++) {
        dac_hide[i].style.display = 'none';
      }
    }
  });
}

/**
 * Klaviyo Opt-in Triggers
 */
var _learnq = window._learnq || [];
var trackedFormSubmissions = new Set(); // Track which forms we've already sent events for to avoid duplicate firing

window.addEventListener('klaviyoForms', function (e) {
  // if (dacKlaviyoSendView(e.detail.formId) && (e.detail.type == 'open' || e.detail.type == 'embedOpen')) {
  //   _learnq.push(['track', 'Viewed Form - ' + dacKlaviyoName(e.detail.formId), { formId: e.detail.formId }]);
  // }

  if (e.detail.type == 'submit' || e.detail.type == 'redirectedToUrl') {
    // Create unique key for this form submission
    const submissionKey = e.detail.formId + '-submit';

    // Only track if we haven't already tracked this submission
    if (!trackedFormSubmissions.has(submissionKey)) {
      trackedFormSubmissions.add(submissionKey);

      _learnq.push(['track', 'Filled Out Form - ' + dacKlaviyoName(e.detail.formId), { formId: e.detail.formId }]);

      // FB lead
      fbq('track', 'Lead');
    }
  }
});

function dacKlaviyoName(formId) {
  if (formId == 'SRs9K4') {
    return '"Filled Out Form - Welcome 10 - Mobile';
  } else if (formId == 'SyRS5m') {
    return 'Filled Out Form - Welcome 10 - Desktop';
  } else if (formId == 'YgpMRn') {
    return 'TGFD Club - Free 60 Days';
  }
  let d = document.getElementsByClassName('klaviyo-form-' + formId);
  if (d.length > 0 && d[0].dataset.name != undefined) {
    return d[0].dataset.name;
  }
  return formId;
}

// function dacKlaviyoSendView(formId) {
//   let d = document.getElementsByClassName('klaviyo-form-' + formId);
//   if (d[0] != undefined && !d[0].hasAttribute('data-no-view-event')) {
//     return true;
//   }
// }
/*DAC - Load More / scroll-triggered paging on Collection page with bundles logic */
const dacLoadMore = {
  wrapper: null,
  button: null,
  observer: null,
  loading: false,
  autoLoads: 0,
};

document.addEventListener('DOMContentLoaded', () => {
  initLoadMore();

  const container = document.querySelector('#ProductGridContainer');
  if (container) {
    new MutationObserver(() => initLoadMore()).observe(container, { childList: true, subtree: true });
  }
});

function initLoadMore() {
  const wrapper = document.querySelector('.load-more-wrapper');
  const btn = document.getElementById('load-more');

  // A different button means the section was re-rendered (facet or sort change),
  // so drop the old observer and start the auto-load allowance over.
  if (btn !== dacLoadMore.button) {
    dacLoadMoreStopObserving();
    dacLoadMore.button = btn;
    dacLoadMore.wrapper = wrapper;
    dacLoadMore.loading = false;
    dacLoadMore.autoLoads = 0;
  }

  if (!btn || !wrapper) return;

  if (!btn.dataset.bound) {
    btn.dataset.bound = 'true';
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      loadMorePage(false);
    });
  }

  // Load the first few pages automatically as the shopper nears the bottom, then
  // hand back to the button so the footer stays reachable.
  const limit = parseInt(wrapper.dataset.autoLoadLimit, 10) || 0;
  if (!dacLoadMore.observer && limit > 0 && 'IntersectionObserver' in window) {
    dacLoadMore.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        if (dacLoadMore.autoLoads >= limit) {
          dacLoadMoreStopObserving();
          return;
        }
        if (dacLoadMore.loading) return;
        loadMorePage(true);
      },
      // Start fetching before the wrapper is actually on screen so the next
      // batch is usually in place by the time the shopper reaches it.
      { rootMargin: '600px 0px' }
    );
    dacLoadMore.observer.observe(wrapper);
  }
}

function dacLoadMoreStopObserving() {
  if (dacLoadMore.observer) {
    dacLoadMore.observer.disconnect();
    dacLoadMore.observer = null;
  }
}

function dacLoadMoreAnnounce(message) {
  const status = dacLoadMore.wrapper && dacLoadMore.wrapper.querySelector('.load-more-status');
  if (status) status.textContent = message;
}

function loadMorePage(auto) {
  const btn = dacLoadMore.button;
  const wrapper = dacLoadMore.wrapper;
  const grid = document.querySelector('#product-grid');
  if (!btn || !grid || dacLoadMore.loading) return;

  const url = btn.getAttribute('data-next-url');
  if (!url) return;

  dacLoadMore.loading = true;
  if (auto) dacLoadMore.autoLoads += 1;

  btn.textContent = 'Loading...';
  btn.setAttribute('aria-busy', 'true');

  // Request just this section instead of the whole page — same markup, a fraction
  // of the bytes, and far less work for DOMParser.
  const sectionId = wrapper && wrapper.dataset.sectionId;
  const fetchUrl = sectionId
    ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId)
    : url;

  fetch(fetchUrl)
    .then((response) => {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    })
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = doc.querySelectorAll('#product-grid > li.grid__item:not(.grid__item-banner)');

      // The rendered section carries its own button, so the next URL comes straight
      // from Liquid rather than from scraping localised pagination labels.
      const nextButton = doc.getElementById('load-more');
      const nextUrl = nextButton && nextButton.getAttribute('data-next-url');

      const seenHandles = new Set(
        [...grid.querySelectorAll('li.grid__item:not(.grid__item-banner)')]
          .map((item) => item.dataset.handle)
          .filter((handle) => handle)
      );

      const fragment = document.createDocumentFragment();
      let added = 0;

      items.forEach((li) => {
        const handle = li.dataset.handle;
        if (handle && seenHandles.has(handle)) return;
        if (handle) seenHandles.add(handle);
        fragment.appendChild(document.importNode(li, true));
        added += 1;
      });

      if (added > 0) {
        grid.appendChild(fragment);

        // Re-apply bundle ordering for price/alphabetical/date sorts
        if (typeof sortBundles === 'function') sortBundles();

        dacLoadMoreAnnounce(added + (added === 1 ? ' more product loaded' : ' more products loaded'));
      }

      dacLoadMore.loading = false;

      if (nextUrl) {
        btn.setAttribute('data-next-url', nextUrl);
        btn.textContent = 'Load More';
        btn.removeAttribute('aria-busy');
      } else {
        dacLoadMoreAnnounce('All products loaded');
        dacLoadMoreStopObserving();
        btn.remove();
        dacLoadMore.button = null;
      }
    })
    .catch((err) => {
      console.error('Load More error', err);
      dacLoadMore.loading = false;
      btn.textContent = 'Try Again';
      btn.removeAttribute('aria-busy');
      // Don't keep auto-firing at a failing endpoint — let the shopper retry.
      dacLoadMoreStopObserving();
    });
}
